export function validateTimeOfDay(data) {
  const { startHour, startMinute, endHour, endMinute } = data;
  if (startHour < 0 || endHour < 0 || startHour > 24 || endHour > 24)
    return [false, 'Hours must be in between 0 and 24'];
  if (startMinute < 0 || endMinute < 0 || startMinute > 59 || endMinute > 59)
    return [false, 'Minutes must be in between 0 and 59'];
  const startMinutes = startHour * 60 + startMinute;
  const endMinutes = endHour * 60 + endMinute;
  if (startMinutes > endMinutes)
    return [false, 'Start time must be before end time.'];
  return [true, ''];
}
